import "../../Assets/scss/pages/widget-manage-plan.scss";

import { useTranslation } from "react-i18next";
import DashboardPageTitle from "../../Components/InnerPageTitle";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import { useSelector, useDispatch } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import AllUserOnlyActivePlanInfo from "../../Components/ManagePlan/CurrentActivePlanInfo";

import AllUserAllPlanInfo from "../../Components/ManagePlan/AllPlanInfo";
import { SET_MESSAGE } from "../../Actions/Types";

import PlatformWidgetCurrentActivePlanInfo from "../../Components/ManagePlan/PlatformWidgetPlanInfo";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import TourGuide from "../../Components/TourGuide";


// component to render manage plan page
const ManagePlanPage = () => {

  // Redux Data
  const { currentWebsite, currentWebsitePlanStatus, user, websites } = useSelector((store: StoreProptypes) => store);

  // Functions
  const { t } = useTranslation();

  const navigate = useNavigate();
     const dispatch = useDispatch();
           const dataPermission = websites?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
    const paymentSettings = dataPermission && dataPermission[0]?.permissions?.find((i: any) => i?.name === "payment_allowed");
   useEffect(() => {
          if(((user?.parent_id !== 0 &&  user?.parent_id !== 1) && paymentSettings?.name !== "payment_allowed")){
              dispatch({
                  type: SET_MESSAGE,
                  payload: {
                      "toast_message": t(`Please contact admin to purchase plan`),
                      "toast_type": "danger"
                  }
              })
          }
      }, [user?.parent_id]);

  useEffect(() => {
    if (currentWebsite?.platform === 'wix' || currentWebsite?.platform === 'shopify' || currentWebsite?.platform === 'plesk' || currentWebsite?.platform === 'AWS') {
      navigate('/front');
    }
  }, [currentWebsite])

  return (
    <>
    <TourGuide />
      <DashboardPagesTemplate>
        <DashboardPageTitle
          pageTitle={`${t("Manage Plan")}`}
          subPageTitle={`For ${currentWebsite?.domain}`}
        />
        <div className="aioa_dashboard-manage-plan">
          {currentWebsite
            && ((currentWebsite.platform === "wix"
              || currentWebsite.platform === 'shopify'
              || currentWebsite.platform === "Opencart-Pro"
              || currentWebsite.platform === "Magento-Pro")) ? (
            <>
              <PlatformWidgetCurrentActivePlanInfo />
            </>
          ) : (
            <>
              {currentWebsite
                && currentWebsitePlanStatus
                && (
                  <>
                    {currentWebsitePlanStatus.planExpiredData === null
                      && currentWebsitePlanStatus.planName === null ? (
                      <>
                        <AllUserAllPlanInfo />
                      </>
                    ) : (
                      <>
                        {currentWebsitePlanStatus.isExpired ? (
                          <>
                            {currentWebsite.expired_package_detail
                              && currentWebsite.expired_package_detail.length > 0
                              && (
                                <>
                                  {/* <AllUserOnlyExpiredPlanInfo /> */}
                                  <AllUserOnlyActivePlanInfo />
                                </>
                              )}
                          </>
                        ) : currentWebsitePlanStatus.isCanceledPlan
                          ? (
                            <>
                              {/* <AllUserOnlyCanceledPlanInfo /> */}
                              <AllUserOnlyActivePlanInfo />
                            </>
                          ) : (
                            <>
                              {currentWebsite.current_package_only
                                && currentWebsite.current_package_only.length > 0
                                && (
                                  <>
                                    {currentWebsitePlanStatus.isTrial
                                      ? (
                                        <>
                                          {/* <AllUserOnlyTrialPlanInfo /> */}
                                          <AllUserOnlyActivePlanInfo />
                                        </>
                                      ) : currentWebsitePlanStatus.isFreeWidget
                                        ? (
                                          <>
                                            {/* <FreeWidgetPlanInfo /> */}
                                            <AllUserOnlyActivePlanInfo />
                                          </>
                                        ) : (
                                          <>
                                            <>
                                              <AllUserOnlyActivePlanInfo />
                                            </>
                                          </>
                                        )}
                                  </>
                                )}
                            </>
                          )}
                      </>
                    )}
                  </>
                )}
            </>
          )}
        </div>



      </DashboardPagesTemplate>
    </>
  )
}

export default ManagePlanPage;